import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Contrato, ItemContrato } from './contrato.model';
import { AssinantesService } from '../assinantes/assinantes.service';
import { ContratosService } from '../contratos/contratos.services';
import { CobrancaTipoService } from './../cobranca-tipo/cobranca-tipo.service';
import { FilialService } from './../filial/filial.service';
import { ItemSerieService } from './../item-serie/item-serie.service';
import { LogradouroCepService } from './../logradouro-cep/logradouro-cep.service';
import { BairroService } from './../bairro/bairro.service';
import { EnderecoLocalTipoService } from './../endereco-local-tipo/endereco-local-tipo.service';
import { PessoaEndereco } from './../pessoa/pessoa.model';
import { ProdutoPacoteService } from '../produto-pacote/produto-pacote.service';
import { adicionaIconesGrid, formataCEPTxt, formataCurrency } from '../app.config';
import notify from 'devextreme/ui/notify';
import { AutorizacaoTipoService } from '../autorizacao-tipo/autorizacao-tipo.service';
import { BancoAgenciaService } from './../banco-agencia/banco-agencia.service';
import { MotivoCancelamentoService } from './../motivo-cancelamento/motivo-cancelamento.service';
import { ClienteTipoService } from '../cliente-tipo/cliente-tipo.service';
import { listaSimNao } from './../shared/listas-parametros';
import { DxDataGridComponent } from 'devextreme-angular';
import { ContratoAutorizacao } from './../contrato-autorizacao/contrato-autorizacao.model';

@Component({
  selector: 'ntc-contrato',
  templateUrl: './contrato.component.html',
  styleUrls: ['./contrato.component.css']
})
export class ContratoComponent implements OnInit {
  @ViewChild('targetDataGrid') dataGrid: DxDataGridComponent;

  contratoForm: Contrato;

  loadingVisible = false;
  tab = [true, false, false];

  colunasGridAutorizacoes= [];

  listaFilial = null;
  /*
  listaFilial = [
    {Id: '1', Nome: 'Filial 01'},
    {Id: '2', Nome: 'Filial 02'}
  ];*/

  listaAssinante = null;

  listaFaturamentoTipo = [
    {Id: 'POS', Descricao: 'PÓS-PAGO'},
    {Id: 'PRE', Descricao: 'PRÉ-PAGO'}
  ];

  listaSituacao = [
    {Id: 'A', Descricao: 'Ativo'},
    {Id: 'I', Descricao: 'Inativo'},
    {Id: 'B', Descricao: 'Bloqueado'}
  ];

  listaTipoEndereco = [
    {Id: 'RES', Descricao: 'Residencial'},
    {Id: 'COM', Descricao: 'Comercial'},
    {Id: 'COB', Descricao: 'Cobrança'}
  ];

  itemsForm = null;

  listaProdutoPacote = null;
  listaEnderecoLocalTipo = null;
  listaBairro = null;
  listaLogradouroCEP = null;
  listaItemSerie = null;

  listaPontoTipo = [
    {Id: '1', DescricaoPontoTipo: 'Principal'},
    {Id: '2', DescricaoPontoTipo: 'Adicional'},
    {Id: '3', DescricaoPontoTipo: 'Cortesia'}
  ];

  listaCobrancaTipo = null;
  listaAutorizacaoTipo = null;
  listaSimNao = listaSimNao;

  listaMotivoCancelamento = [];
  listaBancoAgencia = [];
  listaClienteTipo = [];

/*
  // implementado diretamente no template
  colunasGridContratoPacotes = null;

  editOptionsGridContratoPacotes = {
    mode: 'popup',
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Pacotes do Contrato',
      showTitle: true,
      width: 700,
      height: 400,
      position: { my: 'top', at: 'top', of: window }
    }
  };

  colunasGridContratoEnderecos = null;

  editOptionsGridContratoEnderecos = {
    mode: 'popup',
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Endereços',
      showTitle: true,
      width: 700,
      height: 400,
      position: { my: 'top', at: 'top', of: window }
    }
  };
*/
  listasForm = [
    {Nome: 'listaAssinante', status: false},
    {Nome: 'listaProdutoPacote', status: false},
    {Nome: 'listaEnderecoLocalTipo', status: false},
    {Nome: 'listaBairro', status: false},
    {Nome: 'listaLogradouroCEP', status: false},
    {Nome: 'listaItemSerie', status: false},
    {Nome: 'listaFilial', status: false},
    {Nome: 'listaCobrancaTipo', status: false},
    {Nome: 'listaAutorizacaoTipo', status: false},
    {Nome: 'listaSimNao', status: true},
    {Nome: 'listaMotivoCancelamento', status: false},
    {Nome: 'listaBancoAgencia', status: false},
    {Nome: 'listaClienteTipo', status: false}
  ];

  constructor(
    private assinanteService: AssinantesService,
    private contratosService: ContratosService,
    private produtoPacoteService: ProdutoPacoteService,
    private enderecoLocalTipoService: EnderecoLocalTipoService,
    private bairroService: BairroService,
    private logradouroCepService: LogradouroCepService,
    private itemSerieService: ItemSerieService,
    private filialService: FilialService,
    private cobrancaTipoService: CobrancaTipoService,
    private autorizacaoTipoService: AutorizacaoTipoService,
    private motivoCancelamentoService: MotivoCancelamentoService,
    private bancoAgenciaService: BancoAgenciaService,
    private clienteTipoService: ClienteTipoService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.loadingVisible = true;

    this.contratoForm = new Contrato();

    // verifica se é alteração ou novo cadastro
    if (this.route.snapshot.params['id'] !== undefined) {
      this.contratosService.getContratoById(this.route.snapshot.params['id'])
        .subscribe(contrato => {
          this.contratoForm = contrato;
        });
    } else {
      this.contratoForm.DtCadastro = new Date();
    }

    // carrega listas
    assinanteService.getAssinantes().subscribe(assinantes => {
      this.listaAssinante = assinantes;
      this.verificarListasCarregadas('listaAssinante');
    },
    error => {
      this.verificarListasCarregadas('listaAssinante');
    });

    produtoPacoteService.getProdutoPacote().subscribe(produtoPacotes => {
      this.listaProdutoPacote = produtoPacotes;
      this.verificarListasCarregadas('listaProdutoPacote');
    },
    error => {
      this.verificarListasCarregadas('listaProdutoPacote');
    });

    enderecoLocalTipoService.getEnderecoLocalTipo().subscribe(enderecosLocalTipo => {
      this.listaEnderecoLocalTipo = enderecosLocalTipo;
      this.verificarListasCarregadas('listaEnderecoLocalTipo');
    },
    error => {
      this.verificarListasCarregadas('listaEnderecoLocalTipo');
    });

    bairroService.getBairros().subscribe(bairros => {
      this.listaBairro = bairros;
      this.verificarListasCarregadas('listaBairro');
    },
    error => {
      this.verificarListasCarregadas('listaBairro');
    });

    logradouroCepService.getLogradouroCeps().subscribe(logradouroCeps => {
      this.listaLogradouroCEP = logradouroCeps;
      this.verificarListasCarregadas('listaLogradouroCEP');
    },
    error => {
      this.verificarListasCarregadas('listaLogradouroCEP');
    });

    itemSerieService.getItensSerie().subscribe(itensSerie => {
      this.listaItemSerie = itensSerie;
      this.verificarListasCarregadas('listaItemSerie');
    },
    error => {
      this.verificarListasCarregadas('listaItemSerie');
    });

    filialService.getFilials().subscribe(filiais => {
      this.listaFilial = filiais;
      this.verificarListasCarregadas('listaFilial');
    },
    error => {
      this.verificarListasCarregadas('listaFilial');
    });

    cobrancaTipoService.getCobrancaTipos().subscribe(cobrancaTipos => {
      this.listaCobrancaTipo = cobrancaTipos;
      this.verificarListasCarregadas('listaCobrancaTipo');
    },
    error => {
      this.verificarListasCarregadas('listaCobrancaTipo');
    });

    autorizacaoTipoService.getAutorizacaoTipos().subscribe(autorizacaoTipos => {
      this.listaAutorizacaoTipo = autorizacaoTipos;
      this.verificarListasCarregadas('listaAutorizacaoTipo');
    },
    error => {
      this.verificarListasCarregadas('listaAutorizacaoTipo');
    });

    motivoCancelamentoService.getMotivoCancelamentos().subscribe(motivosCancelamento => {
      this.listaMotivoCancelamento = motivosCancelamento;
      this.verificarListasCarregadas('listaMotivoCancelamento');
    },
    error => {
      this.verificarListasCarregadas('listaMotivoCancelamento');
    });

    bancoAgenciaService.getBancoAgencias().subscribe(bancoAgencias => {
      this.listaBancoAgencia = bancoAgencias;
      this.verificarListasCarregadas('listaBancoAgencia');
    },
    error => {
      this.verificarListasCarregadas('listaBancoAgencia');
    });

    clienteTipoService.getClienteTipos().subscribe(clienteTipos => {
      this.listaClienteTipo = clienteTipos;
      this.verificarListasCarregadas('listaClienteTipo');
    },
    error => {
      this.verificarListasCarregadas('listaClienteTipo');
    });

  }

  ngOnInit() {
  }

  verificarListasCarregadas(nomeLista: string): boolean {

    // altera o status da lista informada para true
    if (nomeLista !== '') {
      const foundItem = this.listasForm.find((fItem) => fItem.Nome === nomeLista);

      if (foundItem) {
        foundItem.status = true;
      }
    }

    // verifica os status das listas para montar o form  e retirar o backdrop (loading)
    if ( (this.listasForm[0].status === true) &&
         (this.listasForm[1].status === true) &&
         (this.listasForm[2].status === true) &&
         (this.listasForm[3].status === true) &&
         (this.listasForm[4].status === true) &&
         (this.listasForm[5].status === true) &&
         (this.listasForm[6].status === true) &&
         (this.listasForm[7].status === true) &&
         (this.listasForm[8].status === true) &&
         (this.listasForm[9].status === true) &&
         (this.listasForm[10].status === true) &&
         (this.listasForm[11].status === true) &&
         (this.listasForm[12].status === true) ) {

      this.montaForm();

      return true;
    } else {
      return false;
    }
  }

  montaForm = function() {
    /*
    // implementado diretamente no template
    this.colunasGridContratoPacotes = [
      {
        dataField: 'IdProdutoPacote',
        caption: 'Produto Pacote',
        lookup: {
            dataSource: this.listaProdutoPacote,
            displayExpr: 'DescricaoProdutoPacote',
            valueExpr: 'Id'
        }
      },
      {
        dataField: 'IdPontoTipo',
        caption: 'Ponto Tipo',
        lookup: {
            dataSource: this.listaPontoTipo,
            displayExpr: 'DescricaoPontoTipo',
            valueExpr: 'Id'
        }
      },
      {
        dataField: 'ValorContratoPacote',
        dataType: 'number',
        caption: 'Valor Pacote'
      },
      {
        dataField: 'DtFimFidelidade',
        dataType: 'date',
        label: { text: 'Data Fim Fidelidade' },
        editorOptions: { width: '100%' }
      },
      {
        dataField: 'DescricaoLocalizacao',
        dataType: 'text',
        caption: 'Localização'
      },
      {
        dataField: 'Situacao',
        caption: 'Situação',
        lookup: {
            dataSource: this.listaSituacao,
            displayExpr: 'Descricao',
            valueExpr: 'Id'
        }
      }
    ];

    this.colunasGridContratoEnderecos = [
      {
        dataField: 'Complemento',
        dataType: 'text'
      },
      {
        dataField: 'EnderecoLocal.Bairro.Id',
        caption: 'Bairro',
        width: 125,
        lookup: {
            dataSource: this.listaBairro,
            displayExpr: 'NomeBairro',
            valueExpr: 'Id'
        }
      },
      {
        dataField: 'EnderecoLocal.EnderecoLocalTipo.Id',
        caption: 'Tipo Local',
        width: 125,
        lookup: {
            dataSource: this.listaEnderecoLocalTipo,
            displayExpr: 'DescricaoEnderecoLocalTipo',
            valueExpr: 'Id'
        }
      },
      {
        dataField: 'EnderecoLocal.LogradouroCEP.Id',
        caption: 'CEP',
        width: 125,
        lookup: {
            dataSource: this.listaLogradouroCEP,
            displayExpr: 'CEP',
            valueExpr: 'Id'
        }
      },
      {
        dataField: 'EnderecoLocal.NumeroEndereco',
        dataType: 'number'
      }
    ];
    */
    this.itemsForm = [
      {
        itemType: 'group',
        caption: 'Contrato',
        items: [
          {
            dataField: 'Id',
            editorType: 'dxTextBox',
            editorOptions: { disabled: true }
          },
          {
            dataField: 'IdPessoa',
            editorType: 'dxSelectBox',
            label: { text: 'Filial' },
            editorOptions: { items: this.listaFilial, displayExpr: 'Nome', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Filial é obrigatório.'
            }]
          },
          {
            dataField: 'DtCadastro',
            editorType: 'dxDateBox',
            label: { text: 'Data de Cadastro' },
            editorOptions: { width: '100%', disabled: true }
          },
          {
            dataField: 'IdAssinante',
            editorType: 'dxSelectBox',
            label: { text: 'Assinante' },
            editorOptions: { items: this.listaAssinante, displayExpr: 'Pessoa.Nome', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Assinante é obrigatório.'
            }]
          },
          {
            dataField: 'IdMotivoCancelamento',
            editorType: 'dxSelectBox',
            label: { text: 'Motivo de Cancelamento' },
            editorOptions: { items: this.listaMotivoCancelamento, displayExpr: 'DescricaoMotivoCancelamento', valueExpr: 'Id' },
          },
          {
            dataField: 'IdCobrancaTipo',
            editorType: 'dxSelectBox',
            label: { text: 'Tipo de Cobrança' },
            editorOptions: { items: this.listaCobrancaTipo, displayExpr: 'DescricaoCobrancaTipo', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Tipo de Cobrança é obrigatório.'
            }]
          },
          {
            dataField: 'IdBancoAgencia',
            editorType: 'dxSelectBox',
            label: { text: 'Agência Bancária' },
            editorOptions: { items: this.listaBancoAgencia, displayExpr: 'DescricaoBancoAgencia', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Agência Bancária é obrigatório.'
            }]
          },
          {
            dataField: 'IdClienteTipo',
            editorType: 'dxSelectBox',
            label: { text: 'Tipo de Cliente' },
            editorOptions: { items: this.listaClienteTipo, displayExpr: 'DescricaoClienteTipo', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Tipo de Cliente é obrigatório.'
            }]
          },
          {
            dataField: 'DescricaoContrato',
            editorType: 'dxTextBox',
            label: { text: 'Descrição' }
          },
          {
            dataField: 'ValorAdesao',
            editorType: 'dxNumberBox',
            label: { text: 'Valor Adesão' },
            format: 'currency',
            editorOptions: { format: 'R$ #,##0.00' }
          },
          {
            dataField: 'DtInicioVigencia',
            editorType: 'dxDateBox',
            label: { text: 'Data de Início da Vigência' },
            editorOptions: { width: '100%' }
          },
          {
            dataField: 'DtVencimento',
            editorType: 'dxDateBox',
            label: { text: 'Data de Vencimento' },
            editorOptions: { width: '100%' }
          },
          {
            dataField: 'Observacao',
            label: { text: 'Observações' },
            editorType: 'dxTextArea',
            editorOptions: { height: 90 },
            colSpan: '2'
          },
          {
            dataField: 'SituacaoContrato',
            editorType: 'dxSelectBox',
            label: { text: 'Situação' },
            editorOptions: { items: this.listaSituacao, displayExpr: 'Descricao', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Situação é obrigatório.'
            }]
          },
          {
            dataField: 'FaturamentoTipo',
            editorType: 'dxSelectBox',
            label: { text: 'Tipo de Faturamento' },
            editorOptions: { items: this.listaFaturamentoTipo, displayExpr: 'Descricao', valueExpr: 'Id' },
            validationRules: [{
              type: 'required',
              message: 'Tipo de Faturamento é obrigatório.'
            }]
          },
          {
            dataField: 'EstaEmProcesso',
            editorType: 'dxSelectBox',
            label: { text: 'Está em Processo' },
            editorOptions: { items: this.listaSimNao, displayExpr: 'Descricao', valueExpr: 'Id' }
          },
          {
            dataField: 'ContratoReserva',
            editorType: 'dxTextBox',
            label: { text: 'Contrato Reserva' }
          },
          {
            dataField: 'ProtocoloContrato',
            editorType: 'dxSelectBox',
            label: { text: 'Protocolo Contrato' },
            editorOptions: { items: this.listaSimNao, displayExpr: 'Descricao', valueExpr: 'Id' }
          },
          {
            dataField: 'TAG',
            editorType: 'dxTextBox',
            label: { text: 'TAG' }
          },
        ]
      }
      /*
      // implementado diretamente no template
      ,
      {
        itemType: 'group',
        caption: 'Dados Complementares',
        items: [{
          itemType: 'tabbed',
          tabPanelOptions: {
              deferRendering: false
          },
          tabs: [
            {
              title: 'Endereços',
              items: [
                {
                  editorType: 'dxDataGrid',
                  editorOptions: {
                    elementAttr: {
                      id: 'gridTeste'
                    },
                    dataSource: this.contratoForm.ContratoEnderecos,
                    columns: this.colunasGridContratoEnderecos,
                    editing: this.editOptionsGridContratoEnderecos,
                    height: 200
                  }
                }
              ]
            },
            {
              title: 'Pacotes',
              items: [
                {
                  editorType: 'dxDataGrid',
                  editorOptions: {
                    dataSource: this.contratoForm.ContratoPacotes,
                    columns: this.colunasGridContratoPacotes,
                    editing: this.editOptionsGridContratoPacotes,
                    height: 200
                  }
                }
              ]
            }
          ]
        }]
      }*/
    ];

    this.colunasGridAutorizacoes = [
      {
        dataField: 'IdAutorizacaoTipo',
        caption: 'Tipo de Autorização',
        lookup: {
            dataSource: this.listaAutorizacaoTipo,
            displayExpr: 'DescricaoAutorizacaoTipo',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Tipo de Autorização é obrigatório.'
        }]
      },
      {
        dataField: 'Autorizado',
        caption: 'Autorizado',
        lookup: {
            dataSource: this.listaSimNao,
            displayExpr: 'Descricao',
            valueExpr: 'Id'
        },
        validationRules: [{
          type: 'required',
          message: 'Autorizado é obrigatório.'
        }]
      }
    ];

    this.loadingVisible = false;
  };

  gravar = function(params: any) {

    const result = params.validationGroup.validate();

    if (result.isValid) {
      this.sResultado = 'Válido!';

      this.contratosService.gravarContrato(this.contratoForm)
        .subscribe((ret: Contrato) => {
          //console.log(`Contrato gravado com sucesso! ${ret.Id}`);
          notify(`Contrato gravado com sucesso! ${ret.Id}`, 'success', 2000);
          this.router.navigate(['/contratos']);
        },
        error => {
          notify('Erro ao gravar Contrato!', 'error', 2000);
        });

    } else {
      this.sResultado = 'Inválido!';
    }
  };

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onRowInserted(e) {
    const ultimoInserido = this.contratoForm.ContratoPacotes.length - 1;

    if (this.contratoForm.ContratoPacotes[ultimoInserido].ItemsContrato === undefined) {
      this.contratoForm.ContratoPacotes[ultimoInserido].ItemsContrato = [];
    }
  }

  tabAtivo(tabIndex) {
    for (const i in this.tab) {
        this.tab[i] = false;
    }

    this.tab[tabIndex] = true;
  }

  reBind() {
    this.contratoForm.ContratoAutorizacao = this.dataGrid.dataSource as ContratoAutorizacao[];
  }

  onContentReady(e) {
    this.reBind();
  }

  formataCEPLookup = function(row) {
    return formataCEPTxt(row.CEP);
  };

  formataCurrencyAux = function(row) {
    return formataCurrency(row);
  };

  onEditorPreparing(e) {
    // Implementado devido as colunas das grids estarem sendo alimentadas direto no template
    if (e.parentType === 'dataRow' && e.dataField === 'ValorContratoPacote') {
      e.editorName = 'dxNumberBox';
      e.editorOptions.format = 'R$ #,##0.00';

      e.editorOptions.onValueChanged = function(arg) {
          e.setValue(parseFloat(arg.value));
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/contrato/contrato.component.ts